<template>
  <!-- for box-shadow to appear when stacking multiple notifcations -->
  <div
    class="aha-invitation-notification"
  >
    <notification-with-actions
      v-for="(invitation, index) in invitations"
      :z-index="index"
      :key="invitation.id"
      :handleAccept="
        () => handleinvitationsAction('accept', invitation.id)
      "
      :handleDecline="() => handleClickDecline(invitation)"
      :loading="processing"
    >
      <span v-html="getInvitationMessage(invitation)"></span>
    </notification-with-actions>
    <modal-decline-invitation
      @hide="showingModalDecline = false"
      v-if="showingModalDecline"
      :content="getDeclineContentMessage(activeInvitation)"
      :handleDecline="
        () => handleinvitationsAction('decline', activeInvitation.id)"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/constant'
import InvitationApi from '@/api/invitation'
import Util from '@/util'
import NotificationWithActions from './NotificationWithActions.vue'
import ModalDeclineInvitation from '../../modals/DeclineInvitation.vue'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
    NotificationWithActions,
    ModalDeclineInvitation,
  },
  props: {
    handleAccept: {
      type: Function,
      default: () => {},
    },
    handleDecline: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      constants,
      showingModalDecline: false,
      activeInvitation: null,
      invitations: [],
      processing: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),
  },
  mounted() {
    if (!this.currentUser.accountId) { // only for users without team
      this.getInvitations()
    }
  },
  methods: {
    ...mapActions(['setErrorOnInternalServerAction', 'getCurrentUserAction']),
    getInvitationMessage(invitation) {
      return `<strong>${(invitation.user && `${invitation.user.firstName} ${invitation.user.lastName}`) || ''}` +
        ` (${invitation.user && invitation.user.email})</strong> has invited you to join team <strong>${invitation.account && invitation.account.name}</strong>`
    },
    getDeclineContentMessage(invitation) {
      if (!invitation) return ''
      return `Are you sure you want to decline the invitation from <strong>${(invitation.user && `${invitation.user.firstName} ${invitation.user.lastName}`) || ''}` +
        ` (${invitation.user && invitation.user.email})</strong> to join <strong>${invitation.account && invitation.account.name}</strong>?`
    },
    handleClickDecline(invitation) {
      this.activeInvitation = invitation
      this.showingModalDecline = true
      const eventLabel = this.activeInvitation.account.name || ''
      Util.gaTrackEvent(
        gaCategories.PRESENTATION_LIST,
        'Team > Refuse invitation',
        eventLabel,
        '',
        {
          plan: this.currentUser.plan,
        },
      )
    },
    async getInvitations() {
      try {
        this.invitations = await InvitationApi.getGlobalInvitationNotifications({
          invitedEmail: this.currentUser.email,
          status: constants.invitationStatus.PENDING,
        })
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    async handleinvitationsAction(action, invitationId) {
      const status = action === 'accept' ? 'accepted' : 'declined'
      const index = this.invitations.findIndex((n) => n.id === invitationId)
      this.processing = true
      try {
        if (action === 'accept') {
          // hide all except the currently accepted invitation
          this.invitations = [this.invitations[index]]
          const evtLabel = this.invitations[0].account.name || ''
          await InvitationApi.acceptInvitation(invitationId)
          await this.getCurrentUserAction()
          this.invitations = [] // once accepted an invitation, discard all other invitations
          window.localStorage.setItem(constants.workspace.WORKING_MODE, constants.workspace.TEAM)
          this.$store.state.workingMode = constants.workspace.TEAM
          setTimeout(() => {
            const query = {
              from: 'invitation',
            }
            this.$router.push({ name: 'TeamMember', query })
          }, 1000)
          Util.gaTrackEvent(
            gaCategories.PRESENTATION_LIST,
            'Team > Accept invitation',
            evtLabel,
            '',
            {
              plan: this.currentUser.plan,
            },
          )
        } else if (action === 'decline') {
          // Team > Refuse invitation
          await InvitationApi.declineInvitation(invitationId)
          this.$set(this.invitations[index], 'status', status)
          this.invitations = this.invitations
            .filter((ivt) => ivt.status === constants.invitationStatus.PENDING)
          this.invitations = [this.invitations[index]]
          window.localStorage.setItem(constants.workspace.WORKING_MODE,
            constants.workspace.PERSONAL)
          this.$store.state.workingMode = constants.workspace.PERSONAL
          window.location.reload()
        }
        Util.showToastSuccess(`Invitation ${status} successfully`)
      } catch (e) {
        if (e.body && e.body.message) {
          this.setErrorOnInternalServerAction(e.body.message)
        } else {
          this.setErrorOnInternalServerAction('There is a problem with your invitation')
        }
        Sentry.captureException(e)
        this.processing = false
        this.getInvitations()
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-invitation-notification {
  @apply relative z-0;
}
</style>
